import { state } from 'cerebral';

export const latestOrders = (get) => {

  const orders = get(state.orders.orders);

  return orders.slice(0, 5);
};